import script from "./AirCNavBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AirCNavBarItem.vue?vue&type=script&setup=true&lang=js"

import "./AirCNavBarItem.vue?vue&type=style&index=0&id=89e92368&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e92368"]])

export default __exports__